import $ from 'jquery';
import magnificPopup from 'magnific-popup';


/* Adding class on anchor that contains image
********************************************/

if ($('.c-wysiwyg').length) {
	$('.c-wysiwyg p a:has(img), .c-wysiwyg .wp-caption a:has(img)').addClass('c-article__image-link');
	$('.c-wysiwyg img').closest('p').addClass('c-article__image-container');
}



/* IE classes
********************************************/

let isIE = false;
if (/MSIE 10/i.test(navigator.userAgent)) {
	isIE = true;
	$('html').addClass('ie ie-10');
}
if (/rv:11.0/i.test(navigator.userAgent)) {
	isIE = true;
	$('html').addClass('ie ie-11');
}


/* Smooth scroll
********************************************/

const stickyHeight = $( '.c-page-nav__section' ).outerHeight( true );

$('a[href*="#"]:not([href="#"])').click(function () {
	var $this = $(this);
	if ($this.parents('.js-no-smooth-scroll').length == 0 && $this.parents('.js-tabs-nav').length == 0) {
		if (location.pathname.replace(/^\//, '') == this.pathname.replace(/^\//, '') && location.hostname == this.hostname) {
			var target = $(this.hash);
			target = target.length ? target : $('[name=' + this.hash.slice(1) + ']');
			if (target.length) {
				$('html, body').animate({
					scrollTop: target.offset().top - stickyHeight + 1
				}, 500);
				return false;
			}
		}
	}
});



/* Tables
********************************************/

if ($('table').length) {
	$('table').wrap('<div class="c-table-wrapper"></div>');
}



/* Modals
********************************************/

if ($.fn.magnificPopup) {
	$('.js-modal-image').magnificPopup({
		type: 'image',
		closeOnContentClick: false,
		closeBtnInside: false,
		image: {
			verticalFit: true
		},
		titleSrc: 'test',
		closeMarkup: '<button title="%title%" type="button" class="mfp-close c-modal-close">&#215;</button>'
	});

	var startWindowScroll = 0;
	$('.js-modal-open').magnificPopup({
		fixedContentPos: true,
		fixedBgPos: true,
		overflowY: 'auto',
		mainClass: 'c-modal-root',
		showCloseBtn: false,
		removalDelay: 100,
		type: 'inline',
		callbacks: {
			beforeOpen: function() {
				startWindowScroll = $(window).scrollTop();
			},
			open: function(){
				if ( $('.mfp-content').height() < $(window).height() ){
					$('body').on('touchmove', function (e) {
						e.preventDefault();
					});
				};
				$('html').css('overflow', 'visible');
				$('.c-body').addClass('c-body--freeze');
			},
			close: function() {
				$(window).scrollTop(startWindowScroll);
				$('body').off('touchmove');
				$('.c-body').removeClass('c-body--freeze');
			}
		}
	});

	// close modal
	$('body').on('click', '.js-modal-close', function (e) {
		e.preventDefault();
		$.magnificPopup.close();
	});
}
